import React from 'react'
import Link from 'next/link'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import Typography from '@ntuctech/devex-tangram/Typography'
import ConfirmationEmailImg from '../../../../static/Loyalty/ConfirmationEmail'
import Panel from '../../Panel/Panel'
import { ConfirmationEmailHolder } from './MembershipDetails/elements'

const OrderSuccess = ({ email, query, trackOrderSuccess }) => {
  return (
    <Panel data-testid="welcome-panel">
      <ConfirmationEmailHolder>
        <ConfirmationEmailImg className="image" />
        {query.orderSuccess === 'Registration' && (
          <Typography variant="h5">Welcome to Just Wine Club!</Typography>
        )}
        {query.orderSuccess === 'Renewal' && (
          <Typography variant="h5">
            You&apos;ve renewed your membership!
          </Typography>
        )}
        {query.orderSuccess !== 'CardRequest' && (
          <>
            <Typography variant="body2">
              We’ve sent you an email with your membership details to {email}.
            </Typography>
          </>
        )}

        <Link href="/loyalty/programmes/jwc" legacyBehavior>
          <ButtonContained
            fullWidth
            size="s"
            onClick={() => trackOrderSuccess('continue', query.orderSuccess)}
          >
            View my digital membership card
          </ButtonContained>
        </Link>
      </ConfirmationEmailHolder>
    </Panel>
  )
}

export default OrderSuccess
